export function maxItemsForSelect(selectElement) {
  return selectElement.multiple ? null : 1;
}

export function valuesForSelect(value) {
  return (Array.isArray(value) ? value : [value]).filter(Boolean).map(String);
}
